import styled from 'styled-components';
import { dirRTL } from 'src/styles/theme';
import { media } from 'src/styles/designs';

export const Heading = styled.h2`
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  min-height: 70px;

  margin-bottom: 16px;
  padding: 0 0 0 33px;
  ${dirRTL} {
    padding: 0 33px 0 0;
  }

  font-size: 24px;
  font-weight: 300;
  line-height: 1;
  text-transform: uppercase;
  color: ${({ theme }) => theme.text.palette.accent};

  b,
  strong {
    font-weight: 300;
  }

  ${media.w.greaterThanOrEqual.desktop} {
    font-size: 32px;
    padding: 0 !important;
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;

    width: 17px;
    height: 70px;
    clip-path: polygon(0 0, 50% 0, 100% 100%, 100% 100%);
    background: ${({ theme }) => theme.text.palette.accent};

    ${media.w.greaterThanOrEqual.desktop} {
      left: -37px;
    }

    ${dirRTL} {
      left: auto;
      right: 0;
      clip-path: polygon(50% 0, 100% 0, 0 100%, 0 100%);

      ${media.w.greaterThanOrEqual.desktop} {
        right: -37px;
      }
    }
  }
`;
